import React from 'react';
import { Card } from '@dev-go4ellis/go4-design-system';
import './ComparisonTable.scss';

const ROWS = [
  { go4: 'You set the hourly rate and see the fee before you post', agency: 'Bill rate quoted to you; trainer pay undisclosed' },
  { go4: 'Free to post, billed only on hours worked', agency: 'Minimums, retainers or annual contracts' },
  { go4: 'One flat 17.5% on trainer pay', agency: 'Markup varies by market and negotiation' },
  { go4: 'Credentials, insurance and records in your account', agency: 'Documentation handled off-platform' },
];

const ComparisonTable = () => (
  <Card padding="lg" flat className="pl-compare">
    <h3 className="pl-compare__title">Go4 vs. a staffing agency</h3>
    <div className="pl-compare__rows">
      {ROWS.map((row, i) => (
        <div key={i} className="pl-compare__row">
          <div className="pl-compare__cell">
            <div className="pl-compare__label pl-compare__label--go4">Go4</div>
            <div className="pl-compare__go4">{row.go4}</div>
          </div>
          <div className="pl-compare__cell">
            <div className="pl-compare__label">Typical agency</div>
            <div className="pl-compare__agency">{row.agency}</div>
          </div>
        </div>
      ))}
    </div>
  </Card>
);

export default ComparisonTable;
